export default "__VITE_ASSET__S_9SYp01__"